import React, {useState, useEffect} from 'react';
import {withRouter} from "react-router-dom"
import {message} from 'antd';
import api from '../../server/api'
import {getIndexDB, setIndexDB} from '../../server/';
import './index.scss';

const Header = props => {
    const [loginStatus, setLoginStatus] = useState(false);
    const [userInfo, setUserInfo] = useState(props.userInfo);
    
    const loginout = () => {
        api.loginout({cellphone: userInfo.cellphone}).then(res => {
            setIndexDB('token', undefined);
            setIndexDB('userInfo', undefined);
            message.success('退出成功');
            props.history?.push('/login');
        })
    }

    useEffect(() => { // 分页 或 搜索条件变换时执行
        const toeknDB = getIndexDB('token');
        const userInfoDB = getIndexDB('userInfo');
        Promise.all([toeknDB, userInfoDB]).then(res => {
            setLoginStatus(res[0] && res[1])
            setUserInfo(res[1])
        })
    },[props])
  
    return (<>
        {loginStatus && <div className="headerSpan">{userInfo?.user_name}<span onClick={loginout}>退出</span></div>}
    </>)
}

export default withRouter(Header);